import Vue from "vue";
import Vuex from "vuex";
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

Vue.use(Vuex);

import servers from "./store/servers/index";
import servers_edit from "./store/servers/edit";
import environments from "./store/domains/environments";
import manage from "./store/domains/manage/manage";
import mails from "./store/domains/mails/mails";
import ssl from "./store/domains/ssl/ssl";
import dns from "./store/domains/dns/dns";
import backups from "./store/domains/backups/backups";
import logs from "./store/domains/logs/logs";
import ftp from "./store/domains/ftp";
import component_databases from "./store/domains/component_databases/component_databases";
import domain_databases from "./store/domains/domain_databases/domain_databases";
import cronjobs from "./store/domains/cronjobs/cronjobs";
import platformUpdates from "./store/platform-updates";
import doconnector from "./store/connectors/doconnector";
import connectors from "./store/connectors";
import ccsreseller from "./store/ccsreseller";
import user from "./store/user";
import import_whm from "./store/import/import_whm";
import import_cpanel from "./store/import/import_cpanel";
import import_base from "./store/import/import_base";
import utilities from "./store/utilities";
import quota_manager from "./store/quota/quota_manager";
import fail2ban_settings from "./store/fail2ban_settings/fail2ban_settings";
import mail_server_settings from "./store/mail_server_settings/mail_server_settings";
import server_firewall from "./store/server_firewall/server_firewall";
import entities from "./store/entities/entities";

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    modules: {
        servers,
        servers_edit,
        environments,
        manage,
        mails,
        ssl,
        logs,
        ftp,
        component_databases,
        domain_databases,
        platformUpdates,
        doconnector,
        connectors,
        ccsreseller,
        user,
        import_base,
        import_whm,
        import_cpanel,
        utilities,
        quota_manager,
        fail2ban_settings,
        mail_server_settings,
        cronjobs,
        dns,
        backups,
        server_firewall,
        entities
    },
    strict: debug,

    state: {
        csrf: "",
        routes_to_avoid_check_session: [
            "user.logout",
            "login.main",
            "forgot_password.main",
            "reset_password.main",
            "invite_account.main",
            "user.login_as_support"
        ],
        whitelabel: {
            NAME: ""
        }
    },
    mutations: {
        csrf(state, value) {
            state.csrf = value;
        },
        whitelabel(state, value) {
            state.whitelabel = value;
        }
    },
    actions: {
        async csrf({ commit }) {
            try {
                const response = await this._vm.$axios.get(this._vm.$laroute.route("csrf"));
                // handle success
                commit("csrf", response.data);
            } catch (error) {
                // TODO handle CSRF error
            }
        },
        async getWhitelabelSettings({ commit }) {
            try {
                const response = await this._vm.$axios.get(this._vm.$laroute.route("whitelabel"));
                // handle success
                commit("whitelabel", response.data.data);
            } catch (error) {
                // TODO handle CSRF error
            }
        }
    }
});
